import { useNavigate, useParams } from "react-router-dom";
import { ImpactedSymbol } from "../api/client";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export function ImpactedTable({ rows, title }: { rows: ImpactedSymbol[]; title: string }) {
  const { projectId = "", repoId = "" } = useParams();
  const navigate = useNavigate();

  function handleRowClick(fqName: string) {
    navigate(`/projects/${projectId}/repos/${repoId}/explore?symbol=${encodeURIComponent(fqName)}`);
  }

  return (
    <div>
      <h4>{title} <span className="muted">({rows.length})</span></h4>
      <Card className="orgs-create-card">
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell className="projects-th">Symbol</TableCell>
                  <TableCell className="projects-th">Kind</TableCell>
                  <TableCell className="projects-th">Depth</TableCell>
                  <TableCell className="projects-th">File</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((r) => (
                  <TableRow key={r.id} className="projects-row"
                    onClick={() => handleRowClick(r.fq_name)}
                    sx={{ cursor: "pointer" }} role="button" tabIndex={0}
                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleRowClick(r.fq_name); } }}>
                    <TableCell><span style={{ fontFamily: '"SF Mono", "Fira Code", monospace', fontSize: "12.5px", color: "#cb2eba" }}>{r.fq_name}</span></TableCell>
                    <TableCell className="projects-td"><span className="pill">{r.kind}</span></TableCell>
                    <TableCell className="projects-td">{r.depth}</TableCell>
                    <TableCell><span style={{ fontFamily: '"SF Mono", "Fira Code", monospace', fontSize: "12px", color: "#cb2eba" }}>{r.file_path}</span></TableCell>
                  </TableRow>
                ))}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} className="projects-td" sx={{ textAlign: "center", color: "rgba(120,120,125,1) !important" }}>None.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </div>
  );
}
